import { useContext } from 'react';
import { StepperContext } from '@/common/components/Stepper/index';

const useStepperContext = () => {
  const {
    currentStep,
    currentStepInd,
    nextStep,
    prevStep,
    steps,
    backToStart,
  } = useContext(StepperContext);
  return {
    currentStep,
    currentStepInd,
    nextStep,
    prevStep,
    steps,
    backToStart,
  };
};

export default useStepperContext;
